// start:ng42.barrel
export * from './data-source.facade';
export * from './data-source.model';
// end:ng42.barrel

